import { setupAccessibility } from '@form/setupAccessibility';
import { setupVoiceButton } from '@form/setupVoiceButton';
import { setupSubmitHandler } from '@form/setupSubmitHandler';
import { Instance } from 'types';
import { AexSearchForm } from '@components/AexSearchForm';
import i18n from '@i18n';

/**
 * Modifies a single container to integrate AgentEx functionality.
 * Adds accessibility features, voice search, and custom submit handling.
 *
 * @param container - The HTML container element to inject into.
 * @param instance - The configuration instance for this form.
 */
export function insertForm(container: HTMLElement, instance: Instance): void {
	if (!container) {
		return;
	}

	AexSearchForm({
		target: container,
		position: 'replace',
		index: instance.index || '1',
		placeholder: instance.searchFieldPlaceholder ?? i18n.t('searchPlaceholder'),
		voiceSearch: instance.voiceSearch,
	});

	container.setAttribute('data-aex-form', 'true');

	const form = document.querySelector('#aex-search-form-' + instance.index) as HTMLFormElement;
	const searchInput = form.querySelector('input[type="search"]') as HTMLInputElement;

	// Apply accessibility attributes and labels
	setupAccessibility(form, searchInput, instance.index || '1');

	// Add voice search functionality if enabled
	if (instance.voiceSearch) {
		setupVoiceButton(form, searchInput, instance);
	}

	// Add custom submit handling
	setupSubmitHandler(form, instance);
}
